import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { IoChevronBack } from 'react-icons/io5';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import Spinner from '../../components/common/Spinner';

const FALLBACK = `제1조 (목적)
본 약관은 (주)조군산업(이하 "회사")이 제공하는 위치기반 서비스에 대해 회사와 이용자 간의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.

제2조 (서비스 내용)
회사는 이용자의 위치정보를 이용하여 다음의 서비스를 제공합니다.
• 현장 위치 확인 및 지도 표시
• 일정 등록 시 주소 기반 위치 안내
• 가까운 현장 및 업체 탐색

제3조 (위치정보 수집)
회사는 서비스 제공을 위해 이용자의 동의하에 위치정보를 수집합니다. 수집하는 위치정보는 다음과 같습니다.
• GPS를 통한 현재 위치 좌표
• 이용자가 입력한 현장 주소 정보

제4조 (위치정보 이용 및 보유)
• 위치정보는 서비스 제공 목적으로만 이용됩니다.
• 위치정보는 서비스 이용 종료 시 즉시 파기합니다.
• 다만, 관련 법령에 따라 보존이 필요한 경우 해당 기간 동안 보관할 수 있습니다.

제5조 (이용자의 권리)
이용자는 언제든지 위치정보 수집에 대한 동의를 철회할 수 있으며, 동의 철회 시 위치기반 서비스 이용이 제한될 수 있습니다.

제6조 (위치정보의 제3자 제공)
회사는 이용자의 사전 동의 없이 위치정보를 제3자에게 제공하지 않습니다. 다만, 법령에 의한 경우는 예외로 합니다.

제7조 (손해배상)
회사의 위치정보 관련 의무 위반으로 이용자에게 손해가 발생한 경우, 이용자는 회사에 손해배상을 청구할 수 있습니다.

부칙
본 약관은 2026년 2월 24일부터 시행합니다.`;

const LocationPolicyPage = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const snap = await getDoc(doc(db, 'policies', 'location'));
        setContent(snap.exists() ? snap.data().content : FALLBACK);
      } catch {
        setContent(FALLBACK);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <Container>
      <Header>
        <BackBtn onClick={() => navigate(-1)}><IoChevronBack size={22} /></BackBtn>
        <Title>위치기반 서비스 이용약관</Title>
        <Spacer />
      </Header>
      <Content>
        {loading ? <Spinner variant="dots" size="md" fullPage /> : <PolicyText>{content}</PolicyText>}
      </Content>
    </Container>
  );
};

export default LocationPolicyPage;

const Container = styled.div`min-height: 100vh; background: #F4F3F8;`;
const Header = styled.div`display: flex; align-items: center; justify-content: space-between; padding: 16px 16px 14px; background: white; border-bottom: 1px solid #EEEEF0;`;
const BackBtn = styled.button`display: flex; padding: 4px; color: #2C3640;`;
const Title = styled.p`font-size: 16px; font-weight: 700; color: #1E2A32;`;
const Spacer = styled.div`width: 30px;`;
const Content = styled.div`padding: 20px 20px 60px;`;
const PolicyText = styled.div`font-size: 14px; color: #5A6B75; line-height: 1.8; white-space: pre-line;`;
